import React from "react";
import {Button, Col, Container, Row} from "react-bootstrap";
import fiveTipsForMoreEmailSecurity from "../assets/blog/5-tips-for-more-email-security.jpg";
import dmarcMadeEasy from "../assets/blog/dmarc-made-easy.png";
import brandIdentificationCard from "../assets/blog/brand-identification-card.png";
import {useNavigate} from "react-router-dom";
import "./LatestBlogs.css";
import {useTranslation} from "react-i18next";

const LatestBlogs = () => {
    const {t} = useTranslation();
    const navigate = useNavigate(); // Hook for programmatic navigation

    const blogData = [
        {
            title: t("pages.home.latestBlog.1.title"),
            description: t("pages.home.latestBlog.1.description"),
            buttonLabel: t("pages.home.latestBlog.1.buttonLabel"),
            link: t("pages.home.latestBlog.1.link"),
            img: {
                source: fiveTipsForMoreEmailSecurity,
                alt: t("pages.home.latestBlog.1.alt")
            }
        },
        {
            title: t("pages.home.latestBlog.2.title"),
            description: t("pages.home.latestBlog.2.description"),
            buttonLabel: t("pages.home.latestBlog.2.buttonLabel"),
            link: t("pages.home.latestBlog.2.link"),
            img: {
                source: dmarcMadeEasy,
                alt: t("pages.home.latestBlog.2.alt")
            }
        },
        {
            title: t("pages.home.latestBlog.3.title"),
            description: t("pages.home.latestBlog.3.description"),
            buttonLabel: t("pages.home.latestBlog.3.buttonLabel"),
            link: t("pages.home.latestBlog.3.link"),
            img: {
                source: brandIdentificationCard,
                alt: t("pages.home.latestBlog.3.alt")
            }
        },
    ];

    return (
        <Container className="my-5">
            <h2 className="text-center mb-4">{t("pages.home.latestBlog.title")}</h2>
            <Row className="g-4">
                {blogData.map((blog, index) => (
                    <Col md={4} sm={6} key={index}>
                        <div className={"text-center bg-white p-5 blog-card"}>
                            <div className={"blog-card-inner"}>
                                <img src={blog.img.source} alt={blog.img.alt} className={"img-fluid rounded shadow"}/>
                            </div>
                            <h5 className={"fw-bold"}>{blog.title}</h5>
                            <p className={"blog-card-inner-description"}>{blog.description}</p>
                            <Button variant="outline-primary" className={"mt-2"}
                                    onClick={() => navigate(blog.link)} // Navigate to the link
                            >
                                {blog.buttonLabel}
                            </Button>
                        </div>
                    </Col>
                ))}
            </Row>
        </Container>
    );
};

export default LatestBlogs;
